import URI from 'uri.js';
import { formatMoney } from '@shopify/theme-currency';
import { getProductJson, updateHistory, getVariantsByColor, getVariantBySingleOption, getAvailableProductColors } from './helpers';
import { handleize } from '../../core/helpers';
import variantImages from './variantImages';
import { propagateWishlistStateToStickyAddToCart } from '../../components/wishlist';
import { nostoRecommendedVariantViewEvent } from '../../components/nosto/events';
import dynamicProductExtra from './dynamic-product-extra';

let selected_single_option = '';
let selected_color_name = '';
let selected_size_name = '';
let selected_color_variants = [];
let selected_variant = [];
let size_index = $('[data-option-size]').data('option-index');
let params = URI(window.location.href);
let retry_wishlist = true;

// All the sizes available for the products are on the page,
// we need to disable the ones that are not available for the selected color
const enableAvailableSizes = () => {
  // const na_size_class = ($('[data-product-overview]').data('oos') && !$('#quicklook-modal').is(':visible')) ? 'inactive' : 'disabled';
  const na_size_class = 'disabled';
  // const na_size_class = ($('#quicklook-modal').is(':visible')) ? 'disabled' : 'inactive';

  const $size_items = $('[data-product-option-size]');
  $size_items.addClass(na_size_class);

  _.each($size_items, (size_item) => {
    _.each(selected_color_variants, (variant) => {
      let aria_label = `Size ${$(size_item).data('size-value')} `;

      if (variant.options[size_index] === $(size_item).data('size-value')) {
        if (variant.available) {
          $(`[data-product-option-size][data-size-value="${$(size_item).data('size-value')}"]`).removeClass(na_size_class);
          $(`[data-product-option-size-sticky][data-size-value="${$(size_item).data('size-value')}"]`).removeClass(na_size_class).removeAttr(na_size_class);
          aria_label = `Size ${$(size_item).data('size-value')} is available`;
        } else {
          aria_label = `Size ${$(size_item).data('size-value')} is unavailable`;
        }

        $(`[data-product-option-size][data-size-value="${$(size_item).data('size-value')}"]`).attr('aria-label', aria_label);
        $(`[data-product-option-size-sticky][data-size-value="${$(size_item).data('size-value')}"]`).attr('aria-label', aria_label);
      }
    });
  });

  // Select the first size available if the active one is not available for the selected color
  if ($('[data-product-option-size].active').hasClass(na_size_class)) {
    $('[data-product-option-size]').removeClass('active');

    _.each($size_items, (size_item) => {
      if (!$(size_item).hasClass(na_size_class) && !$('[data-product-option-size].active').length) {
        $(size_item).addClass('active');
        selected_size_name = $(size_item).data('size-value');
      }
    });
  }

  // if (selected_color_name === '') {
  //   $('[data-product-option-sizes-mobile]').attr(na_size_class, na_size_class);
  // } else {
  //   $('[data-product-option-sizes-mobile]').removeAttr(na_size_class);
  // }
};

// Get the selected variant by size or the 1st one
const getSelectedVariant = (filter_by_size) => {
  if (filter_by_size) {
    let filter_search = { option1: selected_size_name };
    if (size_index === 1) { filter_search = { option2: selected_size_name }; }
    if (size_index === 2) { filter_search = { option3: selected_size_name }; }

    return _.filter(selected_color_variants, filter_search)[0];
  }

  return selected_color_variants[0];
};

// Update the cart buttons
const updateAddToCartStatus = () => {
  // if (typeof selected_variant !== 'undefined') {
  //   console.log('updateAddToCartStatus', selected_variant);
  // }

  if (typeof selected_variant !== 'undefined' && selected_variant.available) {
    $('[data-add-to-cart]').prop('disabled', false);
    $('[data-buy-now]').prop('disabled', false);
    $('[data-add-to-cart-available]').removeClass('visually-hidden');
    $('[data-add-to-cart-unavailable]').addClass('visually-hidden');

    return;
  }

  $('[data-add-to-cart]').prop('disabled', true);
  $('[data-buy-now]').prop('disabled', true);
  $('[data-add-to-cart-available]').addClass('visually-hidden');
  $('[data-add-to-cart-unavailable]').removeClass('visually-hidden');
};

const updateOptionLabels = () => {
  $('[data-product-stock-alert] span').empty();
  $('[data-product-stock-alert]').removeClass('active');
  // $('[data-size-info-unavailable]').removeClass('active');
  $('#size-unavailable-modal .product-option__sizes').removeClass('active');
  $('[data-oos-has-choice]').removeClass('active');
  $('[data-oos-has-no-choice]').removeClass('active');

  // Show "select a size" instead of "add to bag" when no size is selected
  $('[data-product-details] [data-add-to-cart-available]').text(window.theme.strings.selectSize);
  $('[data-product-details] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.selectSize);
  $('[data-product-details] [data-add-to-cart]').addClass('need-size');
  $('[data-mobile-sticky-add-to-cart-button] [data-add-to-cart-available]').text(window.theme.strings.selectSize);
  $('[data-mobile-sticky-add-to-cart-button] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.selectSize);
  $('[data-mobile-sticky-add-to-cart-button]').addClass('need-size');
  $('[data-desktop-sticky-add-to-cart] [data-add-to-cart-available]').text(window.theme.strings.selectSize);
  $('[data-desktop-sticky-add-to-cart] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.selectSize);
  $('[data-desktop-sticky-add-to-cart]').addClass('need-size');

  if ($('[data-selected-color]').length) {
    let color_message = 'Please select a color';

    if (selected_color_name === '') {
      $('[data-selected-color]').addClass('unselected');
    } else {
      color_message = selected_color_name;

      // if ($('[data-product-option-size].disabled').length) {
      $('[data-size-info-unavailable]').addClass('active');
      // }

      if ($(`[data-oos-color="${selected_color_name}"]`).length) {
        $(`[data-oos-color="${selected_color_name}"]`).addClass('active');
      }

      if ($('#size-unavailable-modal .product-option__sizes.active').length) {
        $('[data-oos-has-choice]').addClass('active');
      } else {
        $('[data-oos-has-no-choice]').addClass('active');
      }

      $('[data-selected-color]').removeClass('unselected');
    }

    $('[data-selected-color]').html(`<span class="color-name">${color_message.replace('Plus Size - ', '')}<span><span tabindex="-1" aria-hidden="true" class="visually-hidden">color has been selected. Product content has been updated.</span>`);
  }

  if ($('[data-selected-size]').length) {
    let size_message = 'Please select a size';

    if (selected_size_name !== '') {
      if ($('[data-product-option-size].active').length) {
        if ($('[data-selected-size]').length) {
          size_message = selected_size_name;

          // Show "add to bag" instead of "select a size" when a size is selected
          $('[data-product-details] [data-add-to-cart-available]').text(window.theme.strings.addToCart);
          $('[data-product-details] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.addToCart);
          $('[data-product-details] [data-add-to-cart]').removeClass('need-size');
          $('[data-mobile-sticky-add-to-cart-button] [data-add-to-cart-available]').text(window.theme.strings.addToCart);
          $('[data-mobile-sticky-add-to-cart-button] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.addToCart);
          $('[data-mobile-sticky-add-to-cart-button]').removeClass('need-size');
          $('[data-desktop-sticky-add-to-cart] [data-add-to-cart-available]').text(window.theme.strings.addToCart);
          $('[data-desktop-sticky-add-to-cart] [data-add-to-cart-available]').attr('aria-label', window.theme.strings.addToCart);
          $('[data-desktop-sticky-add-to-cart]').removeClass('need-size');
        }
    
        // Stock alert
        const inventory_quantity = $(`[data-product-select] [value="${selected_variant.id}"]`).data('inventory-quantity');
        $('[data-product-stock-alert]').removeClass('active');
        if (inventory_quantity > 0 && inventory_quantity < 3) {
          $('[data-product-stock-alert] span').html(inventory_quantity);
          $('[data-product-stock-alert]').addClass('active');
        }
      }
    }

    $('[data-selected-size]').html(size_message);
  }

  // Price
  let price_html = '';

  if (typeof selected_variant !== 'undefined') {
    price_html += `<span data-product-price>${formatMoney(selected_variant.price, theme.moneyFormat)}</span>`;
    if (selected_variant.compare_at_price !== null && parseFloat(selected_variant.compare_at_price, 10) > parseFloat(selected_variant.price, 10)) {
      price_html += ` <span class="visually-hidden" data-compare-text>Regular price</span><s data-compare-price>${formatMoney(selected_variant.compare_at_price, theme.moneyFormat)}</s>`;
    }
  }

  // Products with colors and no sizes are not supported yet
  if ($('[data-selected-color]').length && $('[data-selected-size]').length) {
    const product = getProductJson();
    if (selected_color_name === '') {
      // Get the product min price
      price_html = `<span data-product-price><span class="price-from" tabindex="0">From </span>${formatMoney(product.price_min, theme.moneyFormat)}</span>`;
    }

    if (selected_color_name !== '' && selected_size_name === '') {
      // Get the min price for the selected color
      let min_price = null;
      _.each(selected_color_variants, (variant) => {
        if (min_price === null || variant.price < min_price) {
          min_price = variant.price;
        }
      });

      price_html = `<span data-product-price><span class="price-from" tabindex="0">From </span>${formatMoney(product.price_min, theme.moneyFormat)}</span>`;
    }
  }

  $('[data-price-wrapper]').html(price_html);

  dynamicProductExtra(selected_color_name);

  // if (window.theme.isZonos && typeof zonos !== 'undefined') {
  //   window.setTimeout(() => {
  //     zonos.displayCurrency();
  //   }, 1);
  // }
};

// Update the social networks related data
const updateOG = () => {
  if (typeof selected_variant === 'undefined') {
    return;
  }

  let og_title = encodeURIComponent($('.product-details__title').first().text());
  if ($('[data-selected-color]').length) {
    og_title += ` - ${$('[data-selected-color] .color-name').first().text()}`;
  }

  // const og_price = $('[data-product-price]').first().text().replace('$', '').replace('From', '');

  const og_url = `${window.location.origin}${window.location.pathname}?variant=${selected_variant.id}`;

  // let og_image = '';
  // if (selected_variant.featured_image === null) {
  //   window.setTimeout(() => {
  //     og_image = $('[data-product-slider] [data-slick-index="0"] img').first().attr('src').replace('_945x', '_2250x').replace('_180x', '_2250x');
  //     $('[data-share-pinterest]').attr('href', `//pinterest.com/pin/create/button/?url=${og_url}&media=${og_image}&amp;description=${og_title}`);
  //   }, 1000);
  // } else {
    
  const og_image = selected_variant.featured_image.src;
  // }

  // const og_url = window.location.href;

  // Needs to be done server side
  /*
  $('[property="og:url"]').attr('content', og_url);
  $('[property="og:title"]').attr('content', og_title);
  $('[property="og:image:alt"]').attr('content', og_title);
  $('[property="product:price:amount"]').attr('content', og_price);  
  $('[property="og:image"]').attr('content', `http:${og_image}`);
  $('[property="og:image:secure_url"]').attr('content', `https:${og_image}`);
  */

  $('[data-share-pinterest]').attr('href', `//pinterest.com/pin/create/button/?url=${og_url}&media=${og_image}&amp;description=${og_title}`);

  $('[data-share-facebook]').attr('href', `//www.facebook.com/sharer.php?u=${encodeURIComponent(og_url)}`);

  $('[data-share-twitter]').attr('href', `//twitter.com/share?text=${og_title}&url=${encodeURIComponent(og_url)}`);

  $('[data-share-email]').attr('href', `mailto:?subject=${og_title}&body=${og_url}`);
};

// Update model info
const updateModelInfo = () => {
  if (!$('.product-overview-v3').length || !$('[data-selected-color]').length) {
    return;
  }

  // const selected_color_name = $('[data-selected-color] .color-name').first().text();
  const selected_color_handle = handleize(selected_color_name);
  const models_data = JSON.parse($('[data-models-json]').html());

  const model_data = _.find(models_data, { option_color: selected_color_handle });

  if (typeof model_data === 'undefined') {
    $('[data-product-model]').empty();
    $('[data-product-model]').closest('.product-model').addClass('inactive');
    return;
  }

  let model_html = '<ul>';

  if (typeof model_data.name !== 'undefined' && model_data.name.length) {
    if (typeof model_data.height !== 'undefined' && model_data.height.length) {
      model_html += `<li>${model_data.name} is ${model_data.height}</li>`;
    } else {
      model_html += `<li>${model_data.name}</li>`;
    }
  }

  if (typeof model_data.nationality !== 'undefined' && model_data.nationality.length) {
    model_html += `<li>Nationality | ${model_data.nationality}</li>`;
  }

  if (typeof model_data.size !== 'undefined' && model_data.size.length) {
    model_html += `<li>Size | ${model_data.size}</li>`;
  }

  if (typeof model_data.fav_thing !== 'undefined' && model_data.fav_thing.length) {
    model_html += `<li>Favorite things | ${model_data.fav_thing}</li>`;
  }

  model_html += '</ul>';

  $('[data-product-model]').html(model_html);
  $('[data-product-model]').closest('.product-model').removeClass('inactive');

  // reset the accordion
  $(window).trigger('resize');
};

const updateWishlistButton = () => {
  if (window._swat) {
    try {
      if (window.triggerSwymVariantEvent && $('[data-product-swym-wishlist]').length > 0) {
        let selected_product_id = parseInt($('[data-product-swym-wishlist]').data('product-id'), 10);
        const selected_variant_id = parseInt(selected_variant.id, 10);
        // let wishlist_button = '.product-actions__wishlist';
        let wishlist_button = '.swym-add-to-wishlist-view-product';
        const variant_object = {};
        variant_object[`${selected_color_name} / ${selected_size_name}`] = selected_variant_id;

        if ($('#quicklook-modal').is(':visible')) {
          selected_product_id = parseInt($('#quicklook-modal [data-product-swym-wishlist]').data('product-id'), 10);
          // selected_variant_id = parseInt($('#quicklook-modal [data-product-option-color].active').data('variant-id'), 10);
          wishlist_button = '#quicklook-modal .swym-add-to-wishlist-view-product';
        }

        // window.wd_swymProductsInit();
        window.SwymViewProducts[selected_product_id].epi = selected_variant_id;
        window.SwymViewProducts[selected_product_id].iu = window.SwymProductVariants[selected_variant_id].iu;
        window.SwymViewProducts[selected_product_id].variants = [variant_object];
        window.triggerSwymVariantEvent(selected_variant_id);
        window._swat.initializeActionButtons(wishlist_button);

        if ($('.sticky-add-to-cart__wishlist').length) {
          window._swat.initializeActionButtons('.sticky-add-to-cart__wishlist');
        }

        // const is_removing = $('.product-actions__wishlist .swym-button').hasClass('swym-added');

        // Enable/disable the wishlist buttons from the sticky add to cart
        propagateWishlistStateToStickyAddToCart();

        /*
        // Show/hide the wishlist button
        $('[data-product-details-wishlist]').removeClass('active');
        $('[data-product-details-wishlist] .swym-button').removeClass('active');

        // if (is_removing) {
        //   $('[data-product-swym-wishlist]').removeClass('swym-added');
        // }

        if (selected_variant.available) {
          $('[data-product-details-wishlist]').addClass('active');
          $('[data-product-details-wishlist] .swym-button').addClass('active');

          // if (!is_removing) {
          //   $('[data-product-swym-wishlist]').addClass('swym-added');
          // }
        }
        */
      }
    } catch (err) {
      console.warn('Swym selectCallback', err);
    }
  } else {
    // Retry one more time, it can take time to initialize
    if (!retry_wishlist) {
      return;
    }
    
    retry_wishlist = false;

    window.setTimeout(() => {
      updateWishlistButton();
    }, 4000);
  }
};

// Select the same color on "Complete the Look" items
const updateColorCompleteTheLook = () => {
  if (!$('[data-complete-look-products]').length) {
    return;
  }

  console.log('updateColorCompleteTheLook');

  let selected_color_handle = '';
  if ($('[data-product-details]').length) {
    selected_color_handle = $('[data-product-overview] [data-product-option-color].active').data('color-handle');
  }

  if (selected_color_handle === '') {
    return;
  }

  _.each($('[data-complete-look-products] [data-product-tile]'), item => {
    if ($(item).find(`[data-color-swatch][data-color-handle="${selected_color_handle}"]`).length) {
      $(item).find(`[data-color-swatch][data-color-handle="${selected_color_handle}"]`).trigger('click');
    }
  });
};

// On first load - Init the correct variant based on the color in url or if only one color is defined for the current product
const selectVariantWithColor = (force_color = '') => {
  try {
    console.log(`[ASTR] selectVariantWithColor(${force_color}) - On first load - Init the correct variant based on the color in url or if only one color is defined for the current product`);

    selected_color_name = (force_color === '') ? params.query.color : force_color;

    document.querySelectorAll('[data-product-details] [data-product-option-size]').forEach(el => el.classList.remove('active'));
    document.querySelectorAll('[data-product-details] [data-product-option-color]').forEach(el => el.classList.remove('active'));
    document.querySelector(`[data-product-details] [data-color-value="${selected_color_name}"]:not(.inactive)`)?.classList.add('active');

    // If the color is not available, we need to select the 1st available color
    if (typeof document.querySelector('[data-product-details] [data-product-option-color].active')?.dataset.colorValue === 'undefined') {
      document.querySelector('[data-product-details] [data-product-option-color]:not(.inactive)').click();
      return;
    }

    selected_color_variants = getVariantsByColor(selected_color_name);
    enableAvailableSizes();
    selected_variant = getSelectedVariant(false);

    if (typeof selected_variant !== 'undefined' && selected_variant !== null) {
      $('[data-product-details] [data-product-select]').val(selected_variant.id).trigger('change');
    }

    if (!$('#quicklook-modal').is(':visible')) {
      updateHistory();
    }

    // updateAddToCartStatus(); // We don't want to do that at the moment since it would show "out of stock" if the first size (XS) is OOS, better to have a greyed out add to cart button
    updateOptionLabels();
    variantImages();
    updateOG();
    updateModelInfo();
    updateWishlistButton();

    // Dispatch events for new functionalities
    document.dispatchEvent(new Event('astr-pdp-color-selected'));
  } catch (error) {
    console.log(error);
  }
};

// On first load - Init the correct variant if no color and no variant id provided in url
const selectVariantWithNoParams = () => {
  try {
    console.log('[ASTR] selectVariantWithNoParams - On first load - Init the correct variant if no color and no variant id provided in url');

    selected_color_name = document.querySelector('[data-product-details] [data-product-option-color]:not(.inactive)')?.dataset.colorValue;

    // Preselect the 1st color
    selectVariantWithColor(selected_color_name);

    /*
    selected_color_variants = getVariantsByColor(selected_color_name);
    selected_variant = getSelectedVariant(false);
    console.log('selected_variant', selected_variant);
    $('[data-product-select]').val(selected_variant.id).trigger('change');
    selected_color_name = '';
    updateOptionLabels();
    variantImages();
  
    $('[data-product-option-color]').removeClass('active');
    $('[data-product-option-size]').removeClass('active');
    */
  } catch (error) {
    console.log(error);
  }
};

// On first load - Init the correct variant if variant id provided in url
const selectVariantWithId = (variant_id) => {
  try {
    console.log('[ASTR] selectVariantWithId - On first load - Init the correct variant if variant id provided in url');

    selected_color_name = document.querySelector('[data-product-details] [data-product-option-color].active')?.dataset.colorValue;
    selected_size_name = document.querySelector('[data-product-details] [data-product-option-size].active')?.dataset.sizeValue;

    // If the color is not available, we need to select the 1st available color
    if (typeof selected_color_name === 'undefined') {
      document.querySelector('[data-product-details] [data-product-option-color]:not(.inactive)').click();
      return;
    }

    if (!$('[data-product-details] [data-product-option-size].active').length) {
      selected_size_name = $('[data-product-details] [data-product-option-size]').first().data('size-value');
    }

    // When color is not automatically pre-selected
    if (!$('[data-product-details] [data-product-option-color].active').length) {
      const product = getProductJson();
      const variant = _.find(product.variants, { id: variant_id });

      if (typeof variant !== 'undefined') {
        selected_color_name = variant.option1;
        selected_size_name = variant.option2;

        // $(`[data-product-option-color][data-color-value="${selected_color_name}"]`).addClass('active');
        // $(`[data-product-option-size][data-size-value="${selected_size_name}"]`).addClass('active');
        $(`[data-product-details] [data-product-option-color][data-color-value="${selected_color_name}"]`).trigger('click');
        $(`[data-product-details] [data-product-option-size][data-size-value="${selected_size_name}"]`).trigger('click');
      }
    }

    // console.log('selected_color_name', selected_color_name);
    // console.log('selected_size_name', selected_size_name);

    selected_color_variants = getVariantsByColor(selected_color_name);
    enableAvailableSizes();
    // console.log('selected_variant 1', selected_variant);
    selected_variant = getSelectedVariant(true);
    // console.log('selected_variant 2', selected_variant);

    // Necessary when the selected size is not available but we still want the 1st size available
    if (typeof selected_variant !== 'undefined') {
      $('[data-product-details] [data-product-select]').val(selected_variant.id).trigger('change');
    }

    if (!$('#quicklook-modal').is(':visible')) {
      updateHistory();
    }

    updateAddToCartStatus();   
    updateOptionLabels();
    variantImages();
    updateOG();
    updateModelInfo();
    updateWishlistButton();

    // Dispatch events for new functionalities
    document.dispatchEvent(new Event('astr-pdp-color-selected'));
  } catch (error) {
    console.log(error);
  }
};

// On first load - Init the correct variant if the product has only one type of option (Gift cards for instance)
const selectVariantWithSingleOption = () => {
  try {
    console.log('[ASTR] selectVariantWithSingleOption - On first load - Init the correct variant if the product has only one type of option (Gift cards for instance)');

    $('[data-single-option-selector] option:selected').val();
    selected_single_option = $('[data-single-option-selector] option:selected').val();
    selected_variant = getVariantBySingleOption(selected_single_option);

    if (typeof selected_variant !== 'undefined' && selected_variant !== null) {
      $('[data-product-select]').val(selected_variant.id).trigger('change');
    }

    updateAddToCartStatus();
    updateHistory();
    updateOptionLabels();
    variantImages();
    updateOG();
    updateModelInfo();
    updateWishlistButton();
  } catch (error) {
    console.log(error);
  }
};

// Select a size from a desktop element or mobile dropdown
const selectSize = ($item) => {
  if ($item.hasClass('active') || $item.hasClass('disabled') || selected_color_name === '') {
    return;
  }

  $('[data-product-option-size]').removeClass('active');
  $item.addClass('active');

  const product_id = $('#quicklook-modal').is(':visible') ? $item.closest('[data-product-scrollable]').data('product-id') : $('[data-product-overview]').data('product-id');
  selected_size_name = $item.data('size-value');
  selected_variant = getSelectedVariant(true);
  // console.log(selected_variant);

  if (typeof selected_variant !== 'undefined' && selected_variant !== null) {
    $('[data-product-select]').val(selected_variant.id).trigger('change');
  }

  updateAddToCartStatus();
  updateHistory();
  updateOptionLabels();
  updateOG();
  updateModelInfo();
  updateWishlistButton();
  nostoRecommendedVariantViewEvent(product_id, selected_variant.id);

  // Dispatch events for new functionalities
  if (window.sessionStorage.getItem('sticky-desktop-add-to-cart-size-selected') !== '1') {
    document.dispatchEvent(new Event('astr-pdp-size-selected'));
  }
  window.sessionStorage.removeItem('sticky-desktop-add-to-cart-size-selected');

  /*
  if ($('[data-product-overview]').data('oos') && !$('#quicklook-modal').is(':visible')) {
    window.esc_now_back_in_stock.triggerRefresh();
  }
  */
};

// product_url is only defined when we come from a quickview
const initSelectVariant = (product_url) => {
  if (typeof product_url !== 'undefined') {
    params = URI(product_url);
  } 

  // Needs to be defined here for the quickview
  size_index = $('[data-option-size]').data('option-index');

  // Select a new color
  $(document).on('click', '[data-product-option-color]', (e) => {
    const $item = $(e.currentTarget);

    if ($item.hasClass('active')) {
      return;
    }

    $('[data-product-option-color]').removeClass('active');
    $item.addClass('active');
  
    const product_id = $('#quicklook-modal').is(':visible') ? $item.closest('[data-product-scrollable]').data('product-id') : $('[data-product-overview]').data('product-id');
    selected_color_name = $item.data('color-value');
    selected_color_variants = getVariantsByColor(selected_color_name);
    enableAvailableSizes();
    selected_variant = getSelectedVariant(($('[data-product-option-size].active').length > 0));
    
    // Enable the correct size if the previously selected variant didn't have any size available
    if (!$('[data-product-option-size].active').length && selected_variant.available && typeof params.query.variant !== 'undefined') {
      $(`[data-size-value="${selected_variant.options[size_index]}"]`).addClass('active');
    }

    if (typeof selected_variant !== 'undefined' && selected_variant !== null) {
      $('[data-product-select]').val(selected_variant.id).trigger('change');
    }

    if ($('[data-product-option-size].active').length) {
      updateAddToCartStatus();
      updateWishlistButton();
      updateHistory();
    }

    updateOptionLabels();
    variantImages();
    updateOG();
    updateModelInfo();
    updateColorCompleteTheLook();
    nostoRecommendedVariantViewEvent(product_id, selected_variant.id);

    // Dispatch events for new functionalities
    if (window.sessionStorage.getItem('sticky-desktop-add-to-cart-color-selected') !== '1') {
      document.dispatchEvent(new Event('astr-pdp-color-selected'));
    }
  });

  // [ADA] Select a new color
  // $(document).on('focus', '[data-product-option-color]', (e) => {
  //   const $item = $(e.currentTarget);
  //   $item.trigger('click');
  // });
  $(document).on('keypress', '[data-product-option-color]', (e) => {
    const key = e.which;
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });

  // Select a new available size
  $(document).on('click', '[data-product-option-size]', (e) => {
    const $item = $(e.currentTarget);
    selectSize($item);
  });

  // [ADA] Select a new available size
  // $(document).on('focus', '[data-product-option-size]', (e) => {
  //   const $item = $(e.currentTarget);
  //   $item.trigger('click');
  // });
  $(document).on('keypress', '[data-product-option-size]', (e) => {
    const key = e.which;
    // Enter / spacebar
    if (key === 13 || key === 32) {
      const $item = $(e.currentTarget);
      $item.trigger('click');
    }
  });

  /*
  // Select a size from the mobile view
  $(document).on('change', '[data-product-option-sizes-mobile]', (e) => {
    const $item = $(e.currentTarget);

    if ($item.val() === '' || $item.val() === null) {
      return;
    }

    // selectSize($item);
    $(`[data-product-option-sizes] [data-product-option-size][data-size-value="${$item.val()}"]`).trigger('click');
  });
  */

  // Select a size from the unavailable modal
  $(document).on('click', '[data-size-oos]', (e) => {
    const $item = $(e.currentTarget);

    $('[data-out-of-stock]').removeClass('non-init');

    $('[data-size-oos]').removeClass('active');
    $item.addClass('active');

    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${$item.data('size-variant-id')}`;
    window.history.replaceState({ path: newUrl }, '', newUrl);
    // window.esc_now_back_in_stock.triggerRefresh();
  });

  // Select a new "single option"
  $(document).on('change', '[data-single-option-selector]', (e) => {
    const $item = $(e.currentTarget);

    selected_single_option = $item.val();
    selected_variant = getVariantBySingleOption(selected_single_option);
    // console.log(selected_variant);
    if (typeof selected_variant !== 'undefined' && selected_variant !== null) {
      $('[data-product-select]').val(selected_variant.id).trigger('change');
    }

    updateAddToCartStatus();
    updateHistory();
    updateOptionLabels();
    variantImages();
    updateOG();
    updateModelInfo();
    updateWishlistButton();
  });

  // Single option products (such as gift cards, gifts with purchases...)
  if ($('[data-single-option-selector]').length) {
    selectVariantWithSingleOption();
    return;
  }

  // No color or variant ID in URL
  if (typeof params.query.color === 'undefined' && typeof params.query.variant === 'undefined') {
    // Only on color swatch, select it
    if ($('[data-product-option-color]').length === 1) {
      selectVariantWithColor($('[data-product-option-color]').data('color-value'));
      return;
    }

    // Multiple color swatches but only one color available, select it
    const available_product_colors = getAvailableProductColors();
    if (available_product_colors.length === 1) {
      selectVariantWithColor(available_product_colors[0]);
      return;
    }
  }

  if ($('[data-product-option-color]').length && $('[data-product-option-size]').length) {
    if (typeof params.query.color !== 'undefined') {
      if ($(`[data-color-value="${params.query.color}"]`).length) {
        selectVariantWithColor();
        return;
      }
    }
  
    if (typeof params.query.variant === 'undefined') {
      selectVariantWithNoParams();
      return;
    }

    selectVariantWithId(Number(params.query.variant));
    return;
  }

  console.log('[ASTR] Variant initialization case not found');
};

export {
  initSelectVariant,
  getSelectedVariant,
  updateWishlistButton,
};
